import type { LocationQueryValue } from 'vue-router';

// Vue Router の route.params は、明らかにstringの値でも型としては string | string[] | undefined になるため、
// 配列かどうかを明示的に判定してstringを取り出す形にしている
export const routeParamToString = (
  param: string | string[] | undefined,
): string => {
  if (typeof param === 'string') {
    return param;
  }

  if (Array.isArray(param) && param.length > 0) {
    return param[0];
  }

  return '';
};

// Vue Router の route.query の値は string | null | (string | null)[] になりうる
// （同名キーが複数指定されると配列になる）ため、配列かどうかを判定して単一の文字列を取り出す。
// 値が無い・空文字・null の場合は null を返す。
export const routeQueryToString = (
  value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | null => {
  const single = Array.isArray(value) ? value[0] : value;
  return single ? single : null;
};
